import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgD2L = (props) => /* @__PURE__ */ _jsx("svg", {
	"xmlns:rdf": "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
	xmlns: "http://www.w3.org/2000/svg",
	"xmlns:cc": "http://creativecommons.org/ns#",
	"xmlns:dc": "http://purl.org/dc/elements/1.1/",
	viewBox: "0 0 241.1 113.69",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(-14.617 -13.648)",
		fill: "#ee7421",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "m72.85 57.093c0-13.093-4.0064-21.722-20.027-21.722h-17.1v72.095h17.1c16.021 0 20.027-8.6238 20.027-21.717v-28.656zm-18.484 70.247h-29.272c-5.8543 0-10.477-4.7751-10.477-10.629v-91.043c0-5.8543 4.6224-10.629 10.477-10.629h29.272c34.2 0 39.591 24.802 39.591 41.744v28.966c0 17.095-5.3911 41.591-39.591 41.591" }),
			/* @__PURE__ */ _jsx("path", { d: "m163.59 127.34h-50.373c-6.1648 0-10.171-4.1591-10.171-10.166 0-16.947 7.5495-27.266 17.41-35.895 14.173-12.325 32.041-19.564 32.041-34.047 0-7.0863-4.0064-14.325-14.478-14.325-6.1648 0-10.324 1.5424-13.709 3.5432-4.4696 2.4639-6.628 5.0856-10.634 5.0856-5.2334 0-10.009-4.3168-10.009-10.013 0-2.7744 0.76875-5.5488 3.6959-7.86 8.3183-6.6231 18.948-10.013 31.425-10.013 25.418 0 34.968 18.332 34.968 33.584 0 32.352-38.975 37.284-47.598 59.928h37.432c5.7016 0 10.166 4.4647 10.166 10.013 0 5.6966-4.4647 10.166-10.166 10.166" }),
			/* @__PURE__ */ _jsx("path", { d: "m245.55 127.34h-49.451c-5.5439 0-10.013-4.4696-10.013-10.166v-92.896c0-5.8494 4.6224-10.629 10.477-10.629 6.0071 0 10.629 4.78 10.629 10.629v82.882h38.359c5.5439 0 10.166 4.4647 10.166 10.013 0 5.6966-4.6224 10.166-10.166 10.166" })
		]
	})
});
export default SvgD2L;
